import { useRef } from "react";
import { useMesfRealtime } from "@dexteel/mesf-core";

/**
 * SP names that should trigger a data refresh on the CAS Data Entry page.
 *
 * Current triggers:
 *   Caster Mold set online/offline -> RBD.EQPCasterSetOnline / EQPCasterSetOffline -> CAS.DEGetProcess
 */
const REFRESH_MESSAGES = new Set(["CAS.DEGetProcess"]);

/**
 * Listens to SignalR messages and triggers a data refresh on the CAS Data Entry page.
 *
 * Supports the current context-based fetching (callback) and a future React Query
 * migration (add queryClient.invalidateQueries here when ready).
 *
 * @param onRefresh - Callback invoked when a relevant message arrives.
 *                    Typically calls `loadData(currentProcessId)`.
 *
 * Uses a ref to avoid stale closures — the latest `onRefresh` is always called
 * even though useMesfRealtime captures the callback once at mount time.
 */
export const useRealtimeRefresh = (onRefresh: () => void) => {
  const callbackRef = useRef(onRefresh);
  callbackRef.current = onRefresh;

  useMesfRealtime({
    onReceiveMessage: (_author: string, message: string) => {
      if (REFRESH_MESSAGES.has(message)) {
        callbackRef.current();
      }
    },
  });
};
